



































import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { StreamingReward, StreamingTransactionTypes } from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';

@Component
export default class StreamingRewardEditor extends Vue {
  @Prop()
  value!:StreamingReward;

  workingReward:StreamingReward | null = null;

  // Make visible to template
  StreamingTransactionTypes:any = StreamingTransactionTypes;

  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as StreamingReward;
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }
}
